module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/th_3-53cade637d85a9be7fc5bac2e9217f6f.jpg";